import {
  GUARANTEED_INVESTMENT_FUND_FEE_TYPE_TO_DV_MAPPING,
  INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING,
  PAC_INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING,
} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

const toDomainValue = (mapping: Record<string, string>, feeType?: string): DomainValueReference | null => {
  if (!feeType || !(feeType in mapping)) return null;

  return {$ref: mapping[feeType]};
};

export const mapInvestmentAccountFeeTypeToDomainValue = (feeType?: string): DomainValueReference | null =>
  toDomainValue(INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING, feeType);

export const mapPacInvestmentAccountFeeTypeToDomainValue = (feeType?: string): DomainValueReference | null =>
  toDomainValue(PAC_INVESTMENT_ACCOUNT_FEE_TYPE_TO_DV_MAPPING, feeType);

export const mapGuaranteedInvestmentFundFeeTypeToDomainValue = (feeType?: string): DomainValueReference | null =>
  toDomainValue(GUARANTEED_INVESTMENT_FUND_FEE_TYPE_TO_DV_MAPPING, feeType);
